import React from 'react'
import { UserPermission } from 'src/constants/user'
import { useSelector } from 'react-redux'
import { getAccessInfo } from 'src/selectors/user'
import { Navigate } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'
import { getHasCustomersToLink } from 'src/selectors/mc'

export const NavigateToInitialRoute = () => {
  const accessInfo = useSelector(getAccessInfo)
  const hasCustomersToLink = useSelector(getHasCustomersToLink)

  if (!accessInfo) {
    return null
  }

  if (hasCustomersToLink) {
    return <Navigate to={ROUTES.LINK_TO_CUSTOMER_URL} />
  }

  if (accessInfo?.permissions?.includes(UserPermission.OnboardingView)) {
    return <Navigate to={ROUTES.CONTRACTOR_ONBOARDINGS_URL} />
  }

  return <Navigate to={ROUTES.CONTRACTORS_URL} />
}
